import clsx from 'clsx';
import SimpleBar, { Props } from 'simplebar-react';

import styles from './Scrollbar.module.css';

export type ScrollbarProps = Props & {
  disableHorizontalScrolling?: boolean;
  disableVerticalScrolling?: boolean;
  className?: string;
};

export function Scrollbar({ children, ...props }: ScrollbarProps) {
  const { disableHorizontalScrolling, disableVerticalScrolling, classNames, className, ...restProps } = props;
  return (
    <SimpleBar
      {...restProps}
      className={clsx(
        styles.scrollbar,
        disableHorizontalScrolling && styles.disableHorizontalScrolling,
        disableVerticalScrolling && styles.disableVerticalScolling,
        classNames,
        className,
      )}
    >
      {children}
    </SimpleBar>
  );
}
